//
//
//
//
//
//

export default {
    props: ['type', 'text', 'action', 'value', 'model', 'fileguid'],
    data () {
        return {
            fileList: [],
            switchObj: {
                add: function () {
                    return {
                        icon: 'el-icon-plus',
                        type: 'success',
                        text: '添加'
                    }
                },
                save: function () {
                    return {
                        icon: 'el-icon-plus',
                        type: 'text',
                        text: '保存'
                    }
                },
                addchild: function () {
                    return {
                        icon: 'el-icon-plus',
                        type: 'text',
                        text: '添加子项'
                    }
                },
                edit: function () {
                    return {
                        icon: 'el-icon-edit-outline',
                        type: 'text',
                        text: '编辑'
                    }
                },
                select: function () {
                    return {
                        icon: 'el-icon-check',
                        type: 'text',
                        text: '选择'
                    }
                },
                update: function () {
                    return {
                        icon: 'el-icon-check',
                        type: 'text',
                        text: '保存'
                    }
                },
                del: function () {
                    return {
                        icon: 'el-icon-delete',
                        type: 'text',
                        text: '删除'
                    }
                },
                audit: function () {
                    return {
                        icon: 'el-icon-news',
                        type: 'text',
                        text: '审核'
                    }
                },
                search: function () {
                    return {
                        icon: 'el-icon-search',
                        type: 'primary',
                        text: '搜索'
                    }
                },
                detail: function () {
                    return {
                        icon: 'el-icon-search',
                        type: 'text',
                        text: '详情'
                    }
                },
                upload: function () {
                    return {
                        icon: 'el-icon-upload2',
                        type: 'text',
                        text: '上传'
                    }
                },
                undo: function () {
                    return {
                        icon: 'el-icon-refresh-left',
                        type: 'text',
                        text: '撤销'
                    }
                },
                back: function () {
                    return {
                        icon: 'el-icon-arrow-left',
                        type: 'text',
                        text: '返回'
                    }
                },
                cancle: function () {
                    return {
                        icon: '',
                        type: '',
                        text: '取消'
                    }
                },
                goin: function () {
                    return {
                        icon: 'el-icon-view',
                        type: 'text',
                        text: '进入'
                    }
                },
                check: function () {
                    return {
                        icon: 'el-icon-success',
                        type: 'text',
                        text: '已核实'
                    }
                },
                download: function () {
                    return {
                        icon: 'el-icon-download',
                        type: 'text',
                        text: '下载'
                    }
                },
                copy: function () {
                    return {
                        icon: 'el-icon-document-copy',
                        type: 'text',
                        text: '复制'
                    }
                },
                '': function () {
                    return {
                        icon: '',
                        type: '',
                        text: ''
                    }
                }
            }
        }
    },
    watch: {
        fileguid: function (n, o) {
            if (n != o) {
                this.queryFile();
            }
        }
    },
    computed: {
        eltype: function () {
            return this.switchObj[this.type]().type;
        },
        elicon: function () {
            return this.switchObj[this.type]().icon;
        },
        eltext: function () {
            return !!this.text ? this.text : this.switchObj[this.type]().text;
        },
        elsize: function () {
            return this.eltype == 'text' ? '' : 'small';
        }
    },
    methods: {
        clickHandler: function () {
            var that = this;

            if(this.type == 'del'){
                ShowConfirm.call(this, '确认操作', 'warning', function() {
                    this.$emit('click');
                }.bind(this), function() {
                    return;
                })
            }else{
                this.$emit('click');
            }

            if (this.type == 'download' && !!this.fileguid) {
                window.open(this.fileList[0].filesavepath);
                return;
            };
            if (this.type == 'search' && !!this.action && !!this.model && !!this.value) {
                $.get(that.action, {
                    page: 1,
                    whereJson: that.model
                }, function (data) {
                    zh.ajaxCalc(data, function (json) {
                        that.$emit('input', json);
                    })
                })
            }
        },
        queryFile: function () {
            if (this.type == 'download' && !!this.fileguid) {
                this.$get(sysUrl + "/sysfile/getfilelist", {
                    id: this.fileguid
                }, function (data) {
                    this.fileList = data || [];
                })
            }
        }
    },
    mounted: function () {
        this.queryFile();
    }
}
